import {
  findUserTokenInStorage,
  logInWithPassword,
  login,
  logOut,
  setUserToken,
  fakeSessionLogIn,
  setFakeSession,
  refreshUserToken,
} from "./authActions";
import { Action } from "../../models/Action";
import { LOGIN_USER_URL } from "../../api/apiRoutes";
import { gaEvent } from "../../../utils/Analitics/ga";
import { GA_LOGIN } from "../../../utils/Analitics/gaEventsConsts";
import qs from "qs";

export const USER_TOKEN = "userToken";
const isTokenExpired = (token: any) => {
  if (!token?.tokenValidTo) {
    return false;
  }

  const expiryTime = new Date(token.tokenValidTo).getTime();

  if (Number.isNaN(expiryTime)) {
    return false;
  }

  return new Date().getTime() > expiryTime;
};

const authMiddleware = (store: any) => (next: (action: Action<any>) => void) => (action: any) => {
  if (action.type === login.fulfilled.toString()) {
    const storedToken = {
      ...action.payload,
      rememberMe: !!action.meta?.arg?.data?.rememberMe,
    };

    if (action.meta?.arg?.data?.rememberMe) {
      localStorage.setItem(USER_TOKEN, JSON.stringify(storedToken));
    } else {
      sessionStorage.setItem(USER_TOKEN, JSON.stringify(storedToken));
    }

    store.dispatch(setUserToken(storedToken));
  }

  if (action.type === logInWithPassword.toString()) {
    store.dispatch(login({ url: LOGIN_USER_URL, data: action.payload }));
    const facilityIds = store.getState().config.facilityIds;
    gaEvent(facilityIds, "...", GA_LOGIN, {}, "");
  }

  if (action.type === logOut.toString()) {
    sessionStorage.removeItem(USER_TOKEN);
    localStorage.removeItem(USER_TOKEN);
    store.dispatch(fakeSessionLogIn());
  }

  if (action.type === refreshUserToken.fulfilled.toString()) {
    const payload = action.payload;
    if (!payload?.sessionToken) {
      sessionStorage.removeItem(USER_TOKEN);
      localStorage.removeItem(USER_TOKEN);
      store.dispatch(fakeSessionLogIn());
    } else {
      const storedToken = { ...payload, rememberMe: true, lastRefreshedAt: Date.now() };
      localStorage.setItem(USER_TOKEN, JSON.stringify(storedToken));
      store.dispatch(setUserToken(storedToken));
    }
  }

  if (action.type === refreshUserToken.rejected.toString()) {
    sessionStorage.removeItem(USER_TOKEN);
    localStorage.removeItem(USER_TOKEN);
    store.dispatch(fakeSessionLogIn());
  }

  if (action.type === findUserTokenInStorage.toString()) {
    const facilityIds = store.getState().config.facilityIds;
    let userToken = localStorage.getItem(USER_TOKEN);
    if (userToken) {
      const parsedUserToken = JSON.parse(userToken);
      if (isTokenExpired(parsedUserToken)) {
        if (parsedUserToken.rememberMe && parsedUserToken.refreshToken) {
          if (!store.getState().auth.loading) {
            store.dispatch(refreshUserToken({ objectIds: facilityIds, refreshToken: parsedUserToken.refreshToken }));
          }
        } else {
          localStorage.removeItem(USER_TOKEN);
          userToken = null;
        }
      } else if (!parsedUserToken.sessionToken || !parsedUserToken.userName) {
        localStorage.removeItem(USER_TOKEN);
        userToken = null;
      } else {
        const currentSessionToken = store.getState().auth.userToken?.sessionToken;
        if (currentSessionToken !== parsedUserToken.sessionToken) {
          if (parsedUserToken.userName.substring(0, 5) === "GUEST") {
            store.dispatch(setFakeSession(parsedUserToken));
          } else {
            store.dispatch(setUserToken(parsedUserToken));
          }
        }
      }
    }
    // Jeśli nie ma tokena w localStorage, sprawdzamy sessionStorage
    if (!userToken) {
      const sessionToken = sessionStorage.getItem(USER_TOKEN);
      if (sessionToken) {
        const parsedSessionToken = JSON.parse(sessionToken);
        if (isTokenExpired(parsedSessionToken)) {
          sessionStorage.removeItem(USER_TOKEN);
        } else if (!parsedSessionToken.sessionToken || !parsedSessionToken.userName) {
          sessionStorage.removeItem(USER_TOKEN);
        } else {
          const currentSessionToken = store.getState().auth.userToken?.sessionToken;
          if (currentSessionToken !== parsedSessionToken.sessionToken) {
            if (parsedSessionToken.userName.substring(0, 5) === "GUEST") {
              store.dispatch(setFakeSession(parsedSessionToken));
            } else {
              store.dispatch(setUserToken(parsedSessionToken));
            }
          }
        }
      }
    }
  }

  if (action.type === fakeSessionLogIn.fulfilled.toString()) {
    const b2bToken = qs.parse(window.location.search.slice(1)).B2BSESSION as string;
    if (b2bToken) {
      const userToken = action.payload;
      if (userToken) {
        const overrideToken = { ...userToken, sessionToken: b2bToken, userName: b2bToken };
        sessionStorage.setItem(USER_TOKEN, JSON.stringify(overrideToken));
        store.dispatch(setUserToken(overrideToken));
      }
    } else {
      sessionStorage.setItem(USER_TOKEN, JSON.stringify(action.payload));
      store.dispatch(setFakeSession(action.payload));
    }
  }

  next(action);
};

export default authMiddleware;
